export const GET_STATUS_STATE = 'GET_STATUS_STATE'
export const GET_COMPLETED_STATES = 'GET_COMPLETED_STATES'
export const GET_SCHEDULED_STATES = 'GET_SCHEDULED_STATES'
export const SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK'
export const GET_FEEDBACK_CATEGORY = 'GET_FEEDBACK_CATEGORY'
export const GET_SALES_DATA = 'GET_SALES_DATA'